/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsBookOpenWithPage: {
  name: 'book-open-with-page';
  data: string;
} = {
  name: 'book-open-with-page',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M14.75 3.519c1.147-.917 2.776-.317 3.165.972l.6-.15A2 2 0 0 1 21 6.28v11.938a2 2 0 0 1-1.515 1.94l-7.22 1.806a.995.995 0 0 1-.728-.079 1.998 1.998 0 0 1-.329-.053L4.515 20.16A2 2 0 0 1 3 18.22V6.28a2 2 0 0 1 2.485-1.94l6.277 1.57 2.989-2.391ZM13 18.586l3-3V5.08l-2.989 2.39a3.017 3.017 0 0 1-.011.01v11.105ZM11 7.78v11.938l-6-1.5V6.281l6 1.5Zm8-1.5-1 .25v9.055A2 2 0 0 1 17.414 17l-2.154 2.154L19 18.22V6.281Z" fill="currentColor"/></svg>`,
};
